import './HomeContent.css'

export default function HomeContent()
{
    return (
        <main className='home-content-wrapper'>
            <div className='know-more-text-wrapper'>
                <p className='know-more-text'>
                    This is the Cyrus Cylinder. The first ever Decleration of Human Rights, written in Iran 539-538 BC.
                </p>
                <p className='know-more-text'>
                    As new violations of Iranian's rights hit the news, they also hit the cylinder. Creating more fragments at eery wound, cry and scream for help of the Iranian people. Creating piece by piece a bigger revolution.
                </p>
                <p className='know-more-text'>
                    So as long as Iranians draw their last breath, we urge you to echo their screams and demand the world listens.
                </p>

                <button className='take-action-button'>take action</button>
                <button onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }} className='scroll-to-top-button'>Back to the top</button>
            </div>
        </main>
    )
}